import {IProfile} from '@/modules/Profile/interfaces/profile.interface';

export namespace IRequestProfileGet {

  export const ACTION: string = 'contacts_get';

  export enum Commands {
    CONTACTS = 'contacts',
  }

  export interface InputParams {
    command: Commands;
    docGUID: string;
  }

  export function convertToInputParams(command: Commands, orderId: string): InputParams {
    return {
      command,
      docGUID: orderId,
    };
  }

  export function convertToOutputResult(data: any): IProfile.ResourceGetResponseDataResult {
    return {
      ...data,
      parkChoice: data.parkChoice ? data.parkChoice : [],
    };
  }
}
